



















import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { timeoutDefault } from '@/utils/common'
import SurgerySolicitationReadOnlyPageComponent from '@/components/Backoffice/surgery-solicitation-readonly-page.vue'
import EventBus from '@/plugins/EventBus'
import BackofficeAutorizacaoStore from './Store/BackofficeAutorizacaoStore'

@Component({ components: { SurgerySolicitationReadOnlyPageComponent } })

export default class ComponentModalVisualizacao extends Vue {
  loadingClose: boolean = false
  loadedSurgeryDetailsSuccesfully: boolean = false

  @Watch('showModalVisualizacao')
  async onShowChange(opened: boolean) {
    if (opened) {
      EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })

      await this.loadingSurgerySolicitationDetails()

      this.loadedSurgeryDetailsSuccesfully = true
      EventBus.$emit('clearLoadingRequest')
    }
  }

  async loadingSurgerySolicitationDetails() {
    const { id: surgerySolicitationId } = this.getBackofficeGlobalStore.solicitacao

    const response = await this.getBackofficeGlobalStore.getSolicitacaoById(surgerySolicitationId)
    if (response.success) {
      const { hospitalId } = this.getBackofficeGlobalStore.solicitacao

      await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
    } else {
      await this.closeModal()
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível carregar as informações da cirurgia', icon: 'warning', color: '#C62828' })
    }
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get showModalVisualizacao() {
    const show = this.getBackofficeGlobalStore.modal.visualizacao
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalVisualizacao(val: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: val })
  }

  get backofficeArea(): string | null | undefined {
    return this.getBackofficeGlobalStore.backofficeArea
  }

  async closeModal() {
    this.loadingClose = true

    await timeoutDefault()
    this.showModalVisualizacao = false
    this.getBackofficeGlobalStore.setDisableCancelarSolicitacaoButton(false)
    this.getBackofficeGlobalStore.clearSolicitacao()
    this.loadedSurgeryDetailsSuccesfully = false

    if (this.backofficeArea === 'regulacao' || this.backofficeArea === 'fidelizacao') {
      await this.backofficeAutorizacaoStore.loadAgendamentosMedicoSearch()
    }

    this.loadingClose = false
  }

  get backofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_visualizacao')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  windowWidth: number = 0

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
